<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar ref="sidebarRef"></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar">view_headline</i>
            <app-navbar></app-navbar>
            <div class="container-fluid mt-5" id="grad1">
                <!-- breadcrumb and title row starts -->
                <div class="row">
                    <div class="col-sm-12">
                        <vs-breadcrumb align="left" :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/Admin/adminDashboard'
                  },

                  {
                    title: 'Event Wizard',

                  },
                  {
                    title: ` ${updateTraining.title} ${formatDateRange(updateTraining.startdate, updateTraining.enddate)}`,
                    active: true,
                    class: 'font-bold'
                  }
                ]"></vs-breadcrumb>
                    </div>
                    <div class="col-sm-12">
                        <div class="heading mt-3">
                            <h3 class="text-secondary">Event Wizard</h3>
                        </div>
                    </div>
                </div>
                <!-- breadcrumb and title row Ends -->
                <div class="row justify-content-center mt-0">
                    <div class="col-11 text-center p-0 mt-3 mb-2">
                        <div class="card px-0 pb-0 mt-3 mb-3">
                            <div class="row">
                                <div class="col-md-12 mx-0">
                                    <form id="msform">
                                        <!-- progressbar -->
                                        <ul id="progressbar">
                                            <li title="Warning! You are not authorized to access." id="NewTraining">
                                                <strong>Event Assignment</strong>
                                            </li>
                                            <li title="Warning! You are not authorized to access." id="PoAssignment">
                                                <strong>P.O Assignment</strong>
                                            </li>
                                            <li @click="trainingInformation()" class="completed" id="TrainingInformation">
                                                <strong>Event Information</strong>
                                            </li>
                                            <li @click="trainerRegistration()" class="completed" id="TrainerRegistration">
                                                <strong>Facilitators' Registration</strong>
                                            </li>
                                            <li @click="trainingAgenda()" class="completed" id="TrainingAgenda">
                                                <strong>Event Agenda</strong>
                                            </li>
                                            <li @click="trainingMaterial()" class="completed" id="Trainingmaterial">
                                                <strong>Upload Material</strong>
                                            </li>
                                            <li @click="trainingAssessment()" class="completed" id="TrainingAssessments">
                                                <strong>Assessments</strong>
                                            </li>

                                            <li @click="traineeReg()" class="completed" id="TraineeRegistration">
                                                <strong>Participants' Registration</strong>
                                            </li>
                                            <li class="active" id="AssessmentReview">
                                                <strong>Review</strong>
                                            </li>
                                            <li @click="trainingCompletion()" id="Completion">
                                                <strong>Completion</strong>
                                            </li>
                                        </ul>
                                        <!-- fieldsets -->
                                        <fieldset style="text-align: left;padding: 30px;">
                                            <!-- Next Step Button Starts  -->
                                            <div class="row">
                                                <div class="col-md-12 mb-2">
                                                    <h5>Event Assessment Execution</h5>
                                                    <div class="text-right" style="margin-top:-40px">
                                                        <router-link :to="{ path: '/dashboard/programOfficer/trainee-registration', query: { trainingId: this.trainingCode}}" class="btn btn-primary btn-sm m-1">Previous Step</router-link>

                                                        <button @click="completeTraining(trainingCode)" class="btn btn-primary btn-sm" v-if="this.trainingData.trainingstatus != 'In Progress'">
                                                            Save & Complete
                                                        </button>

                                                        <button @click="trainingCompletion()" class="btn btn-primary btn-sm" v-else>
                                                            Next Step
                                                        </button>

                                                        <button type="button" v-on:click="allTrainer()" class="btn btn-primary btn-sm m-1">
                                                            <vs-icon icon="refresh" title="Refresh"></vs-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Next Step Button Ends  -->

                                            <!-- row 1 starts  -->
                                            <div class="row">
                                                <div class="col-md-8">
                                                    <div v-if="this.updateTraining.typetraining_id == 1" class="d-flex flex-row bd-highlight mb-3 pl12">

                                                        <div class="bd-highlight">
                                                            <div class="form-check">
                                                                <vs-checkbox v-model="preAssesment" @change="handlePreChange($event)" :disabled="!isDateValid">
                                                                    <b>PreAssesment</b>
                                                                    <br />
                                                                    <span class="text-success">Enable</span>
                                                                </vs-checkbox>
                                                            </div>
                                                        </div>
                                                        <div class="bd-highlight">
                                                            <div class="form-check">
                                                                <vs-checkbox v-model="postAssesment" @change="handlePostChange($event)" :disabled="!preAssesment || !isDateValid">
                                                                    <b>PostAssesment</b>
                                                                    <br />
                                                                    <span class="text-success">Enable</span>
                                                                </vs-checkbox>
                                                            </div>
                                                        </div>
                                                        <div class="bd-highlight">
                                                            <div class="form-check">
                                                                <vs-checkbox v-model="traineefeedback" @change="handleFeedbackChange($event)">
                                                                    <b>Feedback</b>
                                                                    <br />
                                                                    <span class="text-success">Enable</span>
                                                                </vs-checkbox>
                                                            </div>
                                                        </div>
                                                        <div class="bd-highlight">
                                                            <div class="form-check">
                                                                <vs-checkbox v-model="trainingStatus" @change="handleTrainingStatusChange()">
                                                                    <b>Event</b>
                                                                    <br />
                                                                    <span class="text-success">Closure</span>
                                                                </vs-checkbox>
                                                            </div>
                                                        </div>
                                                        <div class="bd-highlight">
                                                            <div class="form-check">
                                                                <vs-checkbox v-model="certificateStatus" @change="handleCertificateStatusChange($event)">
                                                                    <b>Certificate</b>
                                                                    <br />
                                                                    <span class="text-success">Enable</span>
                                                                </vs-checkbox>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-else class="d-flex flex-row bd-highlight mb-3" style="padding-left:12px">
                                                        <div class="bd-highlight">
                                                            <div class="form-check">
                                                                <vs-checkbox v-model="traineefeedback" @change="handleFeedbackChange($event)">
                                                                    <b>Feedback</b>
                                                                    <br />
                                                                    <span class="text-success">Enable</span>
                                                                </vs-checkbox>
                                                            </div>
                                                        </div>
                                                        <div class="bd-highlight">
                                                            <div class="form-check">
                                                                <vs-checkbox v-model="trainingStatus" @change="handleTrainingStatusChange()">
                                                                    <b>Event</b>
                                                                    <br />
                                                                    <span class="text-success">Closure</span>
                                                                </vs-checkbox>
                                                            </div>
                                                        </div>
                                                        <div class="bd-highlight">
                                                            <div class="form-check">
                                                                <vs-checkbox v-model="certificateStatus" @change="handleCertificateStatusChange($event)">
                                                                    <b>Certificate</b>
                                                                    <br />
                                                                    <span class="text-success">Enable</span>
                                                                </vs-checkbox>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <template>
                                                        <div class="options-container">
                                                            <div class="card2 option5">
                                                                <div class="card2-header">
                                                                    <div class="card2-title">Event Details</div>
                                                                    <div class="action-icons">
                                                                        <i class="material-icons" style="font-size: 20px; margin-right: 10px;" @click="copyDetails">content_copy</i>
                                                                        <i class="material-icons" style="font-size: 20px;" @click="shareDetails">share</i>

                                                                    </div>
                                                                </div>

                                                                <div class="card2-content">
                                                                    <div class="detail-item">
                                                                        <strong>URL:</strong>
                                                                        <span>{{ event.url }}</span>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <div class="detail-item">
                                                                                <strong>Event Code:</strong>
                                                                                <span>{{ event.code }}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <div class="detail-item">
                                                                                <strong>Event Password:</strong>
                                                                                <span>{{ event.password }}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>

                                                </div>

                                                <div class="table-responsive mt-1">
                                                    <div class="col-sm-12">
                                                        <!-- new form popup starts -->
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div class="col-sm-12">
                                                                    <div class="scroll-table-container">
                                                                        <table class="table table-hover">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>Sr#</th>
                                                                                    <th>Name</th>
                                                                                    <th>CNIC Number</th>
                                                                                    <th>Contact Number</th>
                                                                                    <th>Username</th>
                                                                                    <th v-if="updateTraining.typetraining_id == 1">Pre</th>
                                                                                    <th v-if="updateTraining.typetraining_id == 1">Post</th>
                                                                                    <th>Potential Trainer</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tr v-for="(item, index) in itemsTrainee" v-bind:key="item.id">
                                                                                <td>{{index+1}}</td>
                                                                                <td v-if="item.name != null" class="text-capitalize">
                                                                                    {{item.name}}
                                                                                </td>
                                                                                <td v-if="item.cnic != null">
                                                                                    {{item.cnic}}
                                                                                </td>
                                                                                <td v-if="item.contactNo != null">
                                                                                    {{item.contactNo}}
                                                                                </td>
                                                                                <td v-if="item.username != null">
                                                                                    {{item.username}}
                                                                                </td>
                                                                                <template v-if="updateTraining.typetraining_id == 1">
                                                                                    <td v-if="item.preassesmentcheck =='found'">
                                                                                        <span>
                                                                                            <vs-icon class="mr-1" icon="check" style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                                                                        </span>
                                                                                    </td>
                                                                                    <td v-else>
                                                                                        <vs-icon class="mr-1" icon="close" style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                                                                    </td>

                                                                                    <td v-if="item.postassesmentcheck =='found'">
                                                                                        <span>
                                                                                            <vs-icon class="mr-1" icon="check" style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                                                                        </span>
                                                                                    </td>
                                                                                    <td v-else>
                                                                                        <vs-icon class="mr-1" icon="close" style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                                                                    </td>

                                                                                </template>
                                                                                <td style="text-align: center;">
                                                                                                <label class="switch">
                                                                                                    <input type="checkbox" :id="'checkbox-' + item.id" :checked="item.potentialTrainer" @change="handleCheckboxChange(item, $event)" />
                                                                                                    <span class="slider"></span>
                                                                                                </label>
                                                                                            </td>
                                                                               
                                                                            </tr>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- new form popup ends -->
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Add Modal -->
        <b-modal v-model="showModal1" title="Event Details" size="lg" @ok="handleSubmit" @cancel="handleCancel" ok-title="Update" ok-variant="primary" cancel-variant="outline-secondary" header-bg-variant="light" header-text-variant="primary" hide-header-close centered>
            <template #modal-title>
                <h4 class="color-06 mb-0">{{updateTraining.title}}</h4>
            </template>
            <div class="event-details">
                <!-- Status Update Section -->
                <div class="status-section p-3 bg-light rounded">
                    <h5 class="mb-3 color-06">Update Type</h5>
                    <div class="row mb-4">
                        <div class="col-4 font-weight-bold text-muted">Event Status:</div>
                        <div class="col-8">
                            <select v-model="closure_status" class="form-control form-control-lg" :class="{ 'is-invalid': submitted && !closure_status }">
                                <option value="">Select Status</option>
                                <option value="Completed">Completed</option>
                                <option value="Cancelled">Cancelled</option>
                                <option value="Postponed">Postponed</option>
                            </select>

                        </div>
                    </div>

                </div>
            </div>
        </b-modal>

        <!-- Confrim Modal -->
        <b-modal v-model="showModal2" title="Confirm Status Change" @ok="eventStatusChange" @cancel="handleCancel" ok-title="Yes" cancel-title="No" header-bg-variant="light" hide-header-close centered>
            <p>Are you sure you want to change the event status?</p>
        </b-modal>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import {
    formatDateRange
} from "../../../utils/DateFormate";

export default {
    name: 'EventDetailsCard',
    data: () => ({
        showModal1: false,
        showModal2: false,
        copied: false,
        isSidebar: false,
        preAssesment: "",
        postAssesment: "",
        traineefeedback: "",
        trainingStatus: "",
        oldTrainingStatus: "",
        certificateStatus: "",
        role: "",
        designation: "",
        valuesArray: [],
        radios1: "",
        gender: "",
        success: "",
        passport: "",
        institute: "",
        passing_year: "",
        certificate: "",
        district: "",
        email: "",
        error: "",
        isEditForm: "",
        cnic: "",
        inValid: [],
        updateTraining: [],
        isForm: true,
        isFormData: false,
        selected: "",
        tabIndex: 0,
        contact_person: "",
        contact_number: "",
        contact_email: "",
        address: "",
        primaryUserId: "",
        userId: "",
        components: {
            // VueTagsInput
        },
        country: 1,
        province: 1,
        tag: "",
        tags: [],
        rolesArr: [],
        registeredTrainerArr: [],
        trainingId: "",
        trainingCode: "",
        roleuser: "",
        departmentArr: [],
        department: "",
        designationArr: [],
        code: "",
        name: "",
        mobilenumber: "",
        thematicareaSelected: "",
        trainingArr: [],
        provinceArr: [],
        districtArr: [],
        degreenameArr: [],
        itemsTrainee: [],
        trainingData: [],
        training_status: "",
        trainingEndDate: "",
        isDateValid: true,
        event: {
            url: 'https://tmisodc.org/#/focalpointlogin',
            code: '',
            password: ''
        },
        closure_status: '',
        submitted: false,
    }),
    
    watch: {
        country(val) {
            this.openLoading();
            axios
                .get(process.env.VUE_APP_BASE_PATH + "/provinces/get/" + val)
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.provinceArr = response.data;
                });
        },
        province(val) {
            this.openLoading();
            axios
                .get(process.env.VUE_APP_BASE_PATH + "/districts/get/" + val)
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.districtArr = response.data;
                });
        }
    },
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        const basePath = process.env.VUE_APP_BASE_PATH;
        if (basePath.includes("dev.tmisodc.org")) {
            this.event.url = 'https://dev.tmisodc.org/#/focalpointlogin'
        }
        //Select all countries

        this.trainingCode = this.$route.query.trainingId;
        this.openLoading();
        axios
            .get(
                process.env.VUE_APP_BASE_PATH +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode

            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.updateTraining = response.data.training;
                this.trainingId = response.data.training.id;
                this.training_status = response.data.training.trainingstatus;
                this.trainingEndDate = response.data.training.enddate;
                this.dateCheck();
                this.allTrainer();
                this.getAllTraining();
                this.preAssesment = response.data?.training?.preassesment_status?? '';
                this.postAssesment = response.data?.training?.postassesment_status?? '';
                this.traineefeedback = response.data?.training?.feedbackstatus?? '';
                this.trainingStatus = response.data?.training?.close_status?? '';
                this.oldTrainingStatus = response.data.training.close_status?? '';
                this.trainingData = response.data.training;
                this.certificateStatus = response.data?.training?.download_certificate_status?? '';
                this.event.code = response.data?.training?.training_unique_id?? '';
                this.event.password = response.data?.training?.training_token?? '';

            });

        //get result of trainers
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/trainers/all/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.valuesArray = response.data;
            });

        //select all provinces
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/provinces/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.provinceArr = response.data;
            });
        //select all district
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/districts/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.districtArr = response.data;
            });
        //select all degree names
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/degreenames/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.degreenameArr = response.data;
            });
        // department
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/departments/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.departmentArr = response.data;
            });
        //designation
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/designations/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.designationArr = response.data;
            });

        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/traineeroles/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.role = response.data[0].id;
            });
        //select all Training Name
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/trainers/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.trainingArr = response.data;
            });
    },
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar,
    },

    methods: {
        formatDateRange,
        handleCheckboxChange(item, event) {
            const isChecked = event.target.checked;

            // API URL - trainingId ko replace karein
            const trainingId = this.trainingId; // Assume aapke component me yeh available hai
            const url = `${process.env.VUE_APP_BASE_PATH}/training/update-potential-trainee/${trainingId}`;

            const payload = {
                traineeId: item.id, // row ka trainee id
                potential_trainer: isChecked // true ya false
            };

            axios.put(url, payload)
                .then(response => {
                    console.log('Updated Successfully:', response.data);
                })
                .catch(error => {
                    console.error('Update Failed:', error);
                });

        },
        copyDetails() {
            navigator.clipboard.writeText(this.detailsText())
                .then(() => this.toastSuccess('Event details copied to clipboard!'))
                .catch(err => this.toastError('Error copying: ' + err));
        },
        shareDetails() {
            const shareData = {
                title: 'Event Details',
                text: this.detailsText(),

            };
            if (navigator.share) {
                navigator.share(shareData)
                    .catch(err => console.error('Error sharing:', err));
            } else {
                alert('Native sharing is not supported on this device/browser.');
            }
        },

        formatDateRange(startDate, endDate) {
            const [startDay, startMonth, startYear] = startDate.split('-');
            const [endDay, endMonth, endYear] = endDate.split('-');

            const monthNames = [
                '', 'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
            ];

            if (startYear === endYear) {
                if (startMonth === endMonth) {
                    if (startDay === endDay) {
                        return `${startDay} ${monthNames[parseInt(startMonth)]} ${startYear}`;
                    }
                    return `${startDay}-${endDay} ${monthNames[parseInt(startMonth)]} ${startYear}`;
                } else {
                    return `${startDay} ${monthNames[parseInt(startMonth)]} - ${endDay} ${monthNames[parseInt(endMonth)]} ${startYear}`;
                }

            } else {
                return `${startDay} ${monthNames[parseInt(startMonth)]} ${startYear} - ${endDay} ${monthNames[parseInt(endMonth)]} ${endYear}`;
            }
        },

        detailsText() {
            const formattedDate = this.formatDateRange(this.updateTraining.startdate, this.updateTraining.enddate);
            return `Event Name: ${this.updateTraining.title}
Event Venue: ${this.updateTraining.venue}
Event Date: ${formattedDate}
URL: ${this.event.url}
Event Code: ${this.event.code}
Event Password: ${this.event.password}`;
        },
        // onclick show wizard steps
        trainingInformation() {
            this.$router.push({
                path: "/dashboard/programOfficer/training-information",
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainerRegistration() {
            this.$router.push({
                path: "/dashboard/programOfficer/trainer-registration",
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainingAgenda() {
            this.$router.push({
                path: "/dashboard/programOfficer/training-agenda",
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainingMaterial() {
            this.$router.push({
                path: "/dashboard/programOfficer/wizardUploadMaterial",
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainingAssessment() {
            //  if (this.trainingType == 1) {
            this.$router.push({
                path: '/dashboard/programOfficer/training-assesment',
                query: {
                    trainingId: this.trainingCode
                }
            });
            // } else {
            //     this.$router.push({
            //         path: '/dashboard/programOfficer/trainee-registration',
            //         query: { trainingId: this.trainingCode }
            //     });
            // }

        },
        traineeReg() {
            this.$router.push({
                path: "/dashboard/programOfficer/trainee-registration",
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainingCompletion() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg(
                    "Please complete all steps by clicking on Save & Next button"
                );
            } else {
                this.$router.push({
                    path: "/dashboard/programOfficer/wizard-completion",
                    query: {
                        trainingId: this.trainingCode
                    }
                });
            }
        },

        completeTraining(code) {
            this.trainingFilterArr = [];
            this.$refs.sidebarRef.unassignedTrainingsCount();
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/training/status/complete/" +
                    code

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.$router.push({
                        name: "wizardCompletion",
                        query: {
                            trainingId: code
                        }
                    });
                });
        },
        unassignedTraining(id) {
            this.openLoading();
            axios
                .post(
                    process.env.VUE_APP_BASE_PATH +
                    "/training/officer/un-assigned/trainee", {
                        trainingId: this.trainingId,
                        trainee: id
                    }

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response.data.success) {
                        this.$toasted.global.successMsg("Training Un Assigned successfully!");
                        this.getAllTraining();
                    }
                });
        },
        assignedTraining(id) {
            this.openLoading();
            axios
                .post(
                    process.env.VUE_APP_BASE_PATH +
                    "/training/officer/assigned/trainee", {
                        trainingId: this.trainingId,
                        trainee: id
                    }

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response.data.success) {
                        this.$toasted.global.successMsg("Assigned Training successfully!");
                        this.getAllTraining();
                    }
                });
        },
        closeEditForm() {
            this.isForm = true;
            this.isEditForm = false;
            this.resetForm();
        },
        editRecord(id) {
            this.isForm = false;
            this.isEditForm = true;
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH + "/trainee/user/" + id + "/edit"

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response) {
                        this.name = response.data.userstrainee.name;
                        this.code = response.data.userstrainee.code;
                        this.mobilenumber = response.data.userstrainee.contactNo;
                        this.email = response.data.userstrainee.username;
                        this.cnic = response.data.cnic;
                        this.passport = response.data.passportNo;
                        this.gender = response.data.gender;
                        this.userId = id;
                        this.primaryUserId = response.data.user_trainee_id;
                        // this will scrollTop to edit form
                        window.scrollTo(0, 0);
                    }
                });
        },
        deleteRecord(id) {
            this.$bvModal
                .msgBoxConfirm("Please confirm that you want to delete?", {
                    title: "Please Confirm",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "Delete",
                    cancelTitle: "Cancel",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value == true) {
                        this.openLoading();
                        axios
                            .post(process.env.VUE_APP_BASE_PATH + "/trainee/delete", {
                                id: id
                            })
                            .then(response => {
                                this.closeLoading();
                                if (response.data.success) {
                                    this.$toasted.global.successMsg("Record has been deleted successfully!");
                                    this.allTrainer();
                                } else if (response.data.error) {
                                    throw response.data.error;
                                }
                            })
                            .catch(error => {
                                this.$toasted.global.errorMsg(error);
                            });
                    }
                });
        },
        getAllTraining() {
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/trainee/get/all/fortraining/" +
                    this.trainingId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.registeredTrainerArr = response.data;
                });
        },
        allTrainer: function allTrainer() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH + "/trainee/show/" + this.trainingId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();

                    this.itemsTrainee = response.data;
                });
        },
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        handlePreChange: function (e) {
            e.stopPropagation();
            e.preventDefault();
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/enable-preassesment/" +
                    this.trainingId +
                    "/" +
                    this.preAssesment

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                });
        },
        handleTrainingStatusChange() {
            if (this.trainingStatus == true) {
                this.showModal1 = true;
            } else {
                this.showModal2 = true;
            }

        },
        handleCancel() {
            this.$nextTick(() => {
                this.trainingStatus = this.oldTrainingStatus;

                if (this.$refs.trainingCheckbox) {
                    this.$refs.trainingCheckbox.$el.querySelector('input').checked = this.oldTrainingStatus;
                }
            });
        },
        handleSubmit() {

            if (!this.closure_status) {
                this.toastError('Please select an event status');
                return;
            }

            this.openLoading();
            axios.put(`${process.env.VUE_APP_BASE_PATH}/training/update-closure-status/${this.trainingId}`, {
                    closure_status: this.closure_status,
                })
                .then(response => {
                    this.closeLoading();
                    if (response.status === 200 && response.data) {
                        this.toastSuccess('Status updated successfully');
                        this.showModal1 = false;
                        this.confirmStatusChange(true);
                    }
                })
                .catch(error => {
                    this.closeLoading();
                    if (error.response && error.response.status === 400) {
                        const errorMessage = error.response.data?.message || 'Invalid request data';
                        this.toastError(errorMessage);
                    } else {
                        this.toastError(error.response?.data?.message || 'Failed to update status');
                    }
                    this.handleCancel();
                    this.showModal1 = false;
                });
        },
        eventStatusChange() {
            this.openLoading();
            axios.put(`${process.env.VUE_APP_BASE_PATH}/training/update-closure-status/${this.trainingId}`, {
                    closure_status: 'Planned',
                })
                .then(response => {
                    this.closeLoading();
                    if (response.status === 200 && response.data) {
                        this.toastSuccess('Status updated successfully');
                        this.showModal2 = false;
                        this.confirmStatusChange(false);
                    }
                })
                .catch(error => {
                    this.closeLoading();
                    if (error.response && error.response.status === 400) {
                        const errorMessage = error.response.data?.message || 'Invalid request data';
                        this.toastError(errorMessage);
                    } else {
                        this.toastError(error.response?.data?.message || 'Failed to update status');
                    }
                    this.handleCancel();
                    this.showModal2 = false;
                });
        },
        confirmStatusChange(data) {
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/close-training/" +
                    this.trainingId +
                    "/" +
                    data

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        // this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                });
        },

        handlePostChange: function (e) {
            e.stopPropagation();
            e.preventDefault();
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/enable-postassesment/" +
                    this.trainingId +
                    "/" +
                    this.postAssesment

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                });
        },
        handleFeedbackChange: function (e) {
            e.stopPropagation();
            e.preventDefault();
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/enable-feedback/" +
                    this.trainingId +
                    "/" +
                    this.traineefeedback

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                });
        },
        handleCertificateStatusChange(e) {
            axios.get(process.env.VUE_APP_BASE_PATH + "/admin/upload-certificates/" + this.trainingId)
                .then(response => {
                    if (response.data.length <= 0) {
                        this.toastError('Please 1st upload Certificate');
                        this.certificateStatus = false;
                        return;
                    } else {
                        e.stopPropagation();
                        e.preventDefault();
                        this.openLoading();
                        axios
                            .get(
                                process.env.VUE_APP_BASE_PATH +
                                "/download-certificate-status/" +
                                this.trainingId +
                                "/" +
                                this.certificateStatus

                            )
                            .then(response => {
                                this.closeLoading();
                            });
                    }
                });

        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        showinputvalue: function (event) {
            this.name = event.target.value;
        },
        detailsRegistration(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.name) {
                this.inValid.push("Name is required.");
            }
            if (!this.gender) {
                this.inValid.push("Gender type is required.");
            }
            if (!this.mobilenumber) {
                this.inValid.push("Mobile Number utype is required.");
            }
            if (!this.email) {
                this.inValid.push("Email type is required.");
            }
            if (!this.country) {
                this.inValid.push("Country type is required.");
            }
            if (!this.province) {
                this.inValid.push("Province type is required.");
            }
            if (!this.district) {
                this.inValid.push("District type is required.");
            }
            if (!this.address) {
                this.inValid.push("Address type is required.");
            }
            if (!this.designation) {
                this.inValid.push("Designation type is required.");
            }
            if (!this.certificate) {
                this.inValid.push("Certificate type is required.");
            }
            if (!this.passing_year) {
                this.inValid.push("Passing Year type is required.");
            }
            if (!this.institute) {
                this.inValid.push("Institute type is required.");
            }
            var phone_no1 = this.mobilenumber;
            if (phone_no1 == null || phone_no1 == undefined) {
                this.inValid.push("Must be valid Number, 0345-9992229");
            } else {
                phone_no1 = phone_no1.replace(/_/g, "");
                if (phone_no1.length < 14) {
                    this.inValid.push("Must be valid Number, 0345-9992229");
                }
            }
            var cnic_var = this.cnic;
            if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
                cnic_var = cnic_var.replace(/_/g, "");
                if (cnic_var.length < 17) {
                    this.inValid.push("Must be valid CNIC, 16101-1114812-3");
                }
            } else if (
                this.passport == undefined ||
                this.passport == null ||
                this.passport == ""
            ) {
                this.inValid.push("Please Enter Passport Number");
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {
                let self = this;
                this.openLoading();
                axios
                    .post(process.env.VUE_APP_BASE_PATH + "/register/trainee", {

                        name: this.name,
                        code: this.code,
                        department_name: this.department,
                        role: this.role,
                        gender: this.gender,
                        contactNo: this.mobilenumber,
                        email: this.email,
                        sessionBy: this.trainingId,
                        statusApproval: 2,
                        //insert trainee information
                        user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                        cnic: this.cnic,
                        passport: this.passport,
                        country: this.country,
                        province: this.province,
                        district: this.district,
                        address: this.address,
                        certificate: this.certificate,
                        passing_year: this.passing_year,
                        designation: this.designation,
                        institute: this.institute,
                        type: "Details Registration"
                    })
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been saved successfully!");
                            self.resetForm();
                            self.allTrainer();
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        //Quick training
        quickRegistration(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.name) {
                this.inValid.push("Name is required.");
            }
            if (!this.mobilenumber) {
                this.inValid.push("Mobile Number is required.");
            }
            if (!this.email) {
                this.inValid.push("Email type is required.");
            }
            if (!this.gender) {
                this.inValid.push("Gender is required.");
            }
            var phone_no1 = this.mobilenumber;
            if (phone_no1 == null || phone_no1 == undefined) {
                this.inValid.push("Must be valid Number, 0345-9992229");
            } else {
                phone_no1 = phone_no1.replace(/_/g, "");
                if (phone_no1.length < 14) {
                    this.inValid.push("Must be valid Number, 0345-9992229");
                }
            }
            var cnic_var = this.cnic;
            if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
                cnic_var = cnic_var.replace(/_/g, "");
                if (cnic_var.length < 17) {
                    this.inValid.push("Must be valid CNIC, 16101-1114812-3");
                }
            } else if (
                this.passport == undefined ||
                this.passport == null ||
                this.passport == ""
            ) {
                this.inValid.push("Please Enter Passport Number");
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {
                // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
                let self = this;
                this.openLoading();
                axios
                    .post(process.env.VUE_APP_BASE_PATH + "/register/trainee", {
                        //insert User informatiion in user table
                        name: this.name,
                        code: this.code,
                        role: this.role,
                        contactNo: this.mobilenumber,
                        email: this.email,
                        gender: this.gender,
                        sessionBy: this.trainingId,
                        //insert trainee quick information in trainee table
                        user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                        cnic: this.cnic,
                        statusApproval: 2,
                        passport: this.passport,
                        type: "Quick Registration"
                    })
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been added successfully!");
                            self.resetForm();
                            self.allTrainer();
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        submitEditForm(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.name) {
                this.inValid.push("Name is required.");
            }
            if (!this.mobilenumber) {
                this.inValid.push("Mobile Number is required.");
            }
            if (!this.email) {
                this.inValid.push("Email type is required.");
            }
            var phone_no1 = this.mobilenumber;
            if (phone_no1 == null || phone_no1 == undefined) {
                this.inValid.push("Must be valid Number, 0345-9992229");
            } else {
                phone_no1 = phone_no1.replace(/_/g, "");
                if (phone_no1.length < 14) {
                    this.inValid.push("Must be valid Number, 0345-9992229");
                }
            }
            var cnic_var = this.cnic;
            if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
                cnic_var = cnic_var.replace(/_/g, "");
                if (cnic_var.length < 17) {
                    this.inValid.push("Must be valid CNIC, 16101-1114812-3");
                }
            } else if (
                this.passport == undefined ||
                this.passport == null ||
                this.passport == ""
            ) {
                this.inValid.push("Please Enter Passport Number");
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {
                // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
                let self = this;
                this.openLoading();
                axios
                    .post(process.env.VUE_APP_BASE_PATH + "/trainee/update", {
                        //insert User informatiion in user table

                        name: this.name,
                        code: this.code,
                        role: this.role,
                        contactNo: this.mobilenumber,
                        email: this.email,
                        //insert trainee quick information in trainee table
                        user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                        cnic: this.cnic,
                        gender: this.gender,
                        passport: this.passport,
                        type: "Quick Registration",
                        id: this.userId,
                        primaryUserId: this.primaryUserId
                    })

                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been updated successfully!");
                            self.resetForm();
                            self.allTrainer();
                            this.isForm = true;
                            this.isEditForm = false;
                        } else if (response.data.error) {
                            self.toastError(response.data.error);
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        resetForm() {
            this.name = "";
            this.cnic = "";
            this.code = "";
            this.passport = "";
            this.gender = "";
            this.mobilenumber = "";
            this.email = "";
            this.country = "";
            this.province = "";
            this.district = "";
            this.address = "";
            this.department_name = "";
            this.designation = "";
            this.certificate = "";
            this.passing_year = "";
            this.institute = "";
        },
        successUpload() {
            this.$vs.notify({
                color: "primary",
                title: "Upload Success",
                text: "Your file is uploaded Successfully."
            });
        },
        showForm() {
            this.isForm = false;
            this.isFormData = true;
        },
        dateCheck() {
            const today = new Date();
            const dateString = this.trainingEndDate;
            const [day, month, year] = dateString.split("-");

            // Create a new date object for the target date
            const targetDate = new Date(`${year}-${month}-${day}`);

            // Add 3 days to the target date
            targetDate.setDate(targetDate.getDate() + 6);

            today.setHours(0, 0, 0, 0);
            targetDate.setHours(0, 0, 0, 0);

            // Compare today's date with the updated target date
            if (today > targetDate) {
                this.isDateValid = false;
            }

        },
    }
};
</script>

<style scoped>
.vs-breadcrumb {
    font-size: 18px !important;
    font-weight: 600 !important;
}

#progressbar .completed {
    color: #06a6e0;
}

#progressbar li.completed:before,
#progressbar li.completed:after {
    background: #06a6e0;
}

#grad1 {
    background-color: #fff;
}

#msform {
    text-align: center;
    position: relative;
    margin-top: 20px;
}

#msform fieldset .form-card {
    background: white;
    border: 0 none;
    border-radius: 0px;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    padding: 20px 40px 30px 40px;
    box-sizing: border-box;
    width: 94%;
    margin: 0 3% 20px 3%;
    position: relative;
}

#msform fieldset {
    padding: 10px;
    background: #f7f7f7;
    border: 0 none;
    border-radius: 2rem;
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    border: 2px solid #ccc;
    padding-bottom: 20px;
    position: relative;
}

#msform fieldset:not(:first-of-type) {
    display: none;
}

#msform fieldset .form-card {
    text-align: left;
    color: #9e9e9e;
}

#msform .action-button {
    width: 100px;
    background: skyblue;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button:hover,
#msform .action-button:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px skyblue;
}

#msform .action-button-previous {
    width: 100px;
    background: #616161;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button-previous:hover,
#msform .action-button-previous:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px #616161;
}

select.list-dt {
    border: none;
    outline: 0;
    border-bottom: 1px solid #ccc;
    padding: 2px 5px 3px 5px;
    margin: 2px;
}

select.list-dt:focus {
    border-bottom: 2px solid skyblue;
}

.card {
    z-index: 0;
    border: none;
    border-radius: 0.5rem;
    position: relative;
}

.fs-title {
    font-size: 25px;
    color: #2c3e50;
    margin-bottom: 10px;
    font-weight: bold;
    text-align: left;
}

#progressbar {
    margin-bottom: 30px;
    overflow: hidden;
    color: lightgrey;
}

#progressbar .active {
    color: #000000;
}

#progressbar li {
    list-style-type: none;
    font-size: 12px;
    width: 9.5%;
    text-align: center;
    float: left;
    position: relative;
}

#progressbar #NewTraining:before {
    content: "1";
}

#progressbar #PoAssignment:before {
    content: "2";
}

#progressbar #TrainingInformation:before {
    content: "3";
}

#progressbar #TrainerRegistration:before {
    content: "4a";
}

#progressbar #TrainingAgenda:before {
    content: "4b";
}

#progressbar #Trainingmaterial:before {
    content: "4c";
}

#progressbar #TrainingAssessments:before {
    content: "4d";
}

#progressbar #TraineeRegistration:before {
    content: "4e";
}

#progressbar #AssessmentReview:before {
    content: "5";
}

#progressbar #Completion:before {
    content: "6";
}

#progressbar li:before {
    width: 35px;
    height: 35px;
    line-height: 30px;
    display: block;
    font-size: 18px;
    color: #ffffff;
    background: lightgray;
    border-radius: 50%;
    margin: 0 auto 10px auto;
    padding: 2px;
}

#progressbar li:after {
    content: "";
    width: 100%;
    height: 2px;
    background: lightgray;
    position: absolute;
    left: 0;
    top: 17px;
    z-index: -1;
}

#progressbar li.active:before,
#progressbar li.active:after {
    background: #000000;
}

.radio-group {
    position: relative;
    margin-bottom: 25px;
}

.radio {
    display: inline-block;
    width: 204;
    height: 104;
    border-radius: 0;
    background: lightblue;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    cursor: pointer;
    margin: 8px 2px;
}

.radio:hover {
    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
}

.radio.selected {
    box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
}

body {
    margin: 0;
    font-family: 'Poppins', sans-serif;
    background: #f0f2f5;
    overflow-x: auto;
}

.options-container {
    display: flex;
    justify-content: end;
    align-items: end;
    margin-bottom: 10px;
}

.card2 {
    position: relative;
    width: 370px;
    padding-bottom: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    animation: fadeIn 0.6s ease-in-out;
}

/* Header common for all cards */
.card2-header {
    position: relative;
    padding: 15px 15px 15px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #06a6e0;
}

.card2-header .card2-title {
    font-size: 18px;
    font-weight: 600;
    color: #fff;
}

.card2-header .action-icons {
    display: flex;
    gap: 10px;
}

.card2-header .action-icons i {
    cursor: pointer;
    transition: transform 0.2s;
    font-size: 18px;
    color: #fff;
}

.card2-header .action-icons i:hover {
    transform: scale(1.1);
}

/* Content styles */
.card2-content {
    padding: 15px 20px;
    font-size: 14px;
    color: #333;
    line-height: 1.6;
}

.detail-item {
    margin-bottom: 12px;
}

.detail-item strong {
    display: block;
    margin-bottom: 4px;
    color: #555;
    font-weight: 800;
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.5px;
}

.detail-item span {
    font-family: 'Roboto Mono', monospace;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Option 5: Bordered Accent Card */
.option5 {
    background: #fff;
    border: 2px solid #d0d6de;
}

.option5 .card-header {
    background: #1a73e8;
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;
}

.pl12 {
    padding-left: 12px;
}

@media screen and (max-width: 1370px) {
    .pl12 {
        padding-left: 0px;
    }
}

.scroll-table-container {
    max-height: 700px;
    overflow-y: scroll;
    position: relative;
}

.scroll-table-container thead th {
    position: sticky;
    top: 0;
    background: white;
    z-index: 2;
}
</style>
